module.exports = __webpack_public_path__ + "img/lead-machine-logo.png";